import DreamRateStatus from "./dream-rate-status"
import Tooltip from "../../../../tool-tip"
import { PENDING_SUBSCRIPTION_STATUS_OPTIONS } from "../../../../../constants"
import { PendingSubscriptionFull } from "../../../../../../types"
import Badge from "../../../../badge"
import InitialsAvatar from "../../../../initials-avatar"
import { getPendingSubscriptionStatus } from "../../../../../utils/dream-rate"

type Props = {
  info: PendingSubscriptionFull
  onClick: (row: PendingSubscriptionFull) => void
}

const EngagementsCell = ({ info, onClick }: Props) => {
  const { email, first_name, last_name } = info

  const status = getPendingSubscriptionStatus(info)
  const selectedStatusOption = PENDING_SUBSCRIPTION_STATUS_OPTIONS.find(
    so => so.id === status
  )

  const name =
    first_name || last_name ? `${first_name} ${last_name}` : "Unnamed"

  const initials = name
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase()

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer" colSpan={2}>
      <div className="flex items-start gap-4">
        <InitialsAvatar initials={initials} size={12} />
        <div>
          <div className="flex items-center">
            <div
              className="font-bold mr-2 hover:border-b border-neutral-500 leading-none"
              onClick={() => onClick(info)}
            >
              {name}
            </div>
            <Tooltip
              toolTipNode={<DreamRateStatus status={status} />}
              placement="top"
              text={selectedStatusOption?.tooltipText ?? ""}
            />
          </div>
          <div className="text-neutral-400 text-sm mt-2">{email}</div>
          <div className="flex items-center mt-2">
            <Badge.Alt className="px-3">
              Dream Rate: {info.trigger_rate}%
            </Badge.Alt>
          </div>
        </div>
      </div>
    </td>
  )
}

export default EngagementsCell
